export const PXFeaturedPosts = (function() {
	'use strict';

	let $blockTitle,$titleArrow, $select, $main,$patnation;

	function init() {
		$blockTitle = $('.block-title');
		$titleArrow  = $('<svg width="18px" height="12px" viewBox="0 0 18 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <title>Arrow</title> <g id="Style-Guide" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linejoin="round"> <g transform="translate(-189.000000, -3530.000000)" id="Arrow" stroke="#4C54F1" stroke-width="2.5"> <g transform="translate(189.000000, 3531.000000)"> <line x1="0" y1="4.58333333" x2="16" y2="4.58333333" id="Stroke-1"></line> <polyline id="Stroke-3" points="9.74117647 0 16 5.00052737 9.74117647 10"></polyline> </g> </g> </g></svg>');
		$select = $('select#pressroom');
		$main = $('.news-main');
		$patnation = $('news-patnation');

		if ($('.pxblock--featured-posts')) {
			updatePaginationLinks();
		}

		events();
	}

	function updatePaginationLinks(){
		let $pressPaginationLinks = $('.pxblock--featured-posts #press .pagination a');
		if ($pressPaginationLinks) {
			$pressPaginationLinks.each(function(){
				let href = $(this).attr('href');

				if (href.includes('?')) {
					let hrefSplit = href.split('?');
					href = hrefSplit[0];
				}

				$(this).attr('href', href+'?type=press');
			});
		}

		let $newsPaginationLinks = $('.pxblock--featured-posts #news .pagination a');
		if ($newsPaginationLinks) {
			$newsPaginationLinks.each(function(){
				let href = $(this).attr('href');

				if (href.includes('?')) {
					let hrefSplit = href.split('?');
					href = hrefSplit[0];
				}

				$(this).attr('href', href+'?type=news');
			});
		}
	}

	function events() {
		$blockTitle.append($titleArrow);
		$select.change(function(){
			let postType = $(this).val();
			updateQueryString(postType);
			$(this).find("option:selected").each(function(){
				var optionValue = $(this).attr("value");
				if(optionValue){
				   $main.not("." + optionValue).hide();
				   $patnation.not("." + optionValue).hide();
				   $("." + optionValue).show();
				} else{
					$main.has('.press').show();
					$patnation.hide();
				}
			});
		});
	}

	function updateQueryString(postType){
		if ('URLSearchParams' in window) {
			let searchParams = new URLSearchParams(window.location.search)
			searchParams.set("type", postType);
			let newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
			history.replaceState(null, '', newRelativePathQuery);
		}
	}

	return {
		init: init
	};
})();
